// ============================================================
// useTeacherStudents Hook
// ============================================================

import { useState, useEffect } from 'react';
import { useSchool } from './useSchool';
import { useTeacherAssignments } from './useTeacherAssignments';
import { useStudents } from './useStudents';
import { useAuth } from './useAuth';

export function useTeacherStudents() {
  const { schoolId } = useSchool();
  const { user } = useAuth();
  const teacherId = user?.teacherId;
  
  const { assignments, loading: assignmentsLoading } = useTeacherAssignments(teacherId);
  const { students, loading: studentsLoading } = useStudents();
  
  const [assignedStudents, setAssignedStudents] = useState([]);
  
  useEffect(() => {
    if (!assignmentsLoading && !studentsLoading && assignments && students) {
      // Find all unique classId + sectionId combinations assigned to the teacher
      const assignedClassSections = assignments.reduce((acc, curr) => {
        const key = `${curr.classId}_${curr.sectionId}`;
        acc[key] = true;
        return acc;
      }, {});
      
      // Filter students who belong to those class/section combos
      const filtered = students.filter(student => {
        const key = `${student.classId}_${student.sectionId}`;
        return assignedClassSections[key];
      });
      
      setAssignedStudents(filtered);
    }
  }, [assignments, students, assignmentsLoading, studentsLoading]);

  return { 
    students: assignedStudents, 
    loading: assignmentsLoading || studentsLoading 
  };
}
